import { useEffect, useState } from 'react';

export const supportLabels={open:'Ricevuta',in_progress:'In lavorazione',resolved:'Risolta'};
export async function supportFetch(session,action,body,query='') {
  const response=await fetch(`/api/billing?service=support&action=${action}${query}`,{
    method:body?'POST':'GET',headers:{Authorization:`Bearer ${session.access_token}`,...(body?{'Content-Type':'application/json'}:{})},
    ...(body?{body:JSON.stringify(body)}:{})
  });
  const data=await response.json();
  if(!response.ok) throw new Error(data.error || 'Segnalazioni non disponibili');
  return data;
}

function RequestRow({item,founder,session,onSaved,restaurants}) {
  const [status,setStatus]=useState(item.status);
  const [reply,setReply]=useState(item.reply);
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState('');
  const [saved,setSaved]=useState(false);
  useEffect(()=>{setStatus(item.status);setReply(item.reply);},[item]);
  async function save() {
    setBusy(true);setError('');setSaved(false);
    try {const result=await supportFetch(session,'founder-update',{id:item.id,version:item.version,status,reply});if(result.request?.id!==item.id)throw new Error('Salvataggio non confermato. Aggiorna le segnalazioni.');await onSaved();setSaved(true);}
    catch(e){setError(e.message);}finally{setBusy(false);}
  }
  return <article className="support-request-row">
    <strong>{founder ? `${restaurants.find(r=>r.id===item.ristorante_id)?.nome || 'Ristorante'} · ` : ''}{item.section}</strong>
    <small>#{item.id.slice(0,8)} · {new Date(item.created_at).toLocaleString('it-IT')} · {supportLabels[item.status]}</small>
    <p className="support-request-text">{item.description}</p>
    {founder ? <details><summary>Gestisci richiesta</summary>
      <label>Stato<select value={status} onChange={e=>{setStatus(e.target.value);setSaved(false);}} disabled={busy}>{Object.entries(supportLabels).map(([key,label])=><option value={key} key={key}>{label}</option>)}</select></label>
      <label>Risposta visibile al ristoratore<textarea value={reply} maxLength={1200} rows={3} onChange={e=>{setReply(e.target.value);setSaved(false);}} disabled={busy}/></label>
      <button className="founder-secondary" disabled={busy} onClick={save}>{busy?'Salvataggio…':'Salva risposta e stato'}</button>
      <small>La risposta compare nell’app. Non vengono inviate email o SMS.</small>
      {saved&&<p role="status">Risposta e stato salvati.</p>}{error&&<p role="alert">{error}</p>}
    </details> : item.reply && <p className="support-request-text"><strong>RistoDaily:</strong> {item.reply}</p>}
  </article>;
}

export default function SupportRequests({session,founder=false,restaurants=[],revision=0}) {
  const [notice,setNotice]=useState('');
  const [data,setData]=useState(null),[error,setError]=useState(''),[page,setPage]=useState(0),[filter,setFilter]=useState('open'),[reload,setReload]=useState(0);
  useEffect(()=>{
    let alive=true;setError('');setData(null);
    supportFetch(session,founder?'founder-list':'list',null,`&page=${page}&status=${filter}`)
      .then(result=>{if(!Array.isArray(result.requests)) throw new Error('Segnalazioni non disponibili');if(alive)setData(result);})
      .catch(e=>{if(alive)setError(e.message);});
    return()=>{alive=false;};
  },[session,founder,page,filter,reload,revision]);
  return <section className={founder?'founder-panel':'support-requests'} aria-label={founder?'Assistenza ristoratori':'Le tue segnalazioni'}>
    <div className="problem-report-actions"><h2>{founder?'Assistenza ristoratori':'Le tue segnalazioni'}</h2><button className="button button-small button-ghost" onClick={()=>setReload(n=>n+1)}>Aggiorna segnalazioni</button></div>
    {founder&&<label>Mostra<select value={filter} onChange={e=>{setFilter(e.target.value);setPage(0);}}><option value="open">Da gestire</option><option value="resolved">Risolte</option><option value="all">Tutte</option></select></label>}
    {error&&<p role="alert">{error}</p>}
    {notice&&<p role="status">{notice}</p>}
    {!data&&!error&&<p role="status">Caricamento segnalazioni…</p>}
    {data&&!data.requests.length&&<p>Nessuna segnalazione {founder&&filter==='open'?'da gestire':'in questa pagina'}.</p>}
    {data?.requests.map(item=><RequestRow key={item.id} item={item} founder={founder} session={session} restaurants={restaurants} onSaved={()=>{setNotice('Risposta e stato salvati.');setReload(n=>n+1);}}/>)}
    {data&&(page>0||data.hasMore)&&<div className="problem-report-actions"><button disabled={page===0} onClick={()=>setPage(p=>p-1)}>Precedenti</button><span>Pagina {page+1}</span><button disabled={!data.hasMore} onClick={()=>setPage(p=>p+1)}>Successive</button></div>}
  </section>;
}
